import React, { useState } from 'react'
import XButton from '../XButton'
import { BUTTON_SIZE, BUTTON_STYLE_TYPE } from '../../styles/constants'
import styles from './style.module.scss'
import { useTranslation } from '../../../i18n'

export interface XFAQNavProps {
    categories: { [key: string]: string }
    active: number
}

const XFAQNav = (props: XFAQNavProps) => {
    const { t } = useTranslation(window.LANG_NS)
    const { categories } = props
    const [activeCategory, setActiveCategory] = useState(props.active !== -1 ? props.active : 0)

    const categoryHandler = (index: number, category: string) => {
        setActiveCategory(index)
        window.location.hash = `#${category}`
    }

    return (
        <div className={styles.xFAQ__container}>
            {Object.keys(categories).map((category, index) => {
                return (
                    <div key={index} className={styles.xFAQ__button_container}>
                        <XButton
                            styleType={
                                activeCategory === index ? BUTTON_STYLE_TYPE.FAQ_NAV : BUTTON_STYLE_TYPE.DISABLED
                            }
                            size={BUTTON_SIZE.SMALL}
                            onClick={() => {
                                categoryHandler(index, category)
                            }}
                            ga4_key={t(categories[category], { lang: 'en' })}
                        >
                            {t(categories[category])}
                        </XButton>
                        {activeCategory === index ? (
                            <div className={styles.xFAQ__button_container__active_line}></div>
                        ) : (
                            <div className={styles.xFAQ__line} />
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default XFAQNav
